// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__GDY24","savePackageButton":"ClientWallet_savePackageButton__2sPQ3"};